import Profile from './Profile.vue';

export default Profile;
